import(/* webpackMode: "eager" */ "/app/src/app/auth/page.tsx");
